import { useEffect, useState } from 'react';
import { fetchAudit } from '../lib/dataProvider';
import { PageTitle, StatBlock } from '../components/shared/badges';
import { fmt } from '../components/shared/badges';

const th = 'px-3 py-2 text-[11px] font-bold uppercase tracking-[0.1em] text-slate-500';

export default function JournalAudit() {
  const [rows, setRows] = useState([]);
  const [filtre, setFiltre] = useState('Tous');

  useEffect(() => {
    fetchAudit().then(setRows);
  }, []);

  const visibles = rows.filter((r) => filtre === 'Tous' || r.action === filtre);

  return (
    <div data-testid="journal-audit-page" className="space-y-6">
      <PageTitle
        emoji="🛡️"
        titre="Journal d'activité"
        sous="Corrections et suppressions administrateur — trace non visible par les employés"
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <StatBlock testid="stat-audit-total" titre="Entrées" accent="border-l-slate-900" items={[['Total', fmt(rows.length)]]} />
        <StatBlock testid="stat-audit-modifs" titre="Corrections" accent="border-l-sky-600" items={[['Lignes', fmt(rows.filter((r) => r.action === 'Modification').length)]]} />
        <StatBlock testid="stat-audit-suppressions" titre="Suppressions" accent="border-l-red-600" items={[['Lignes', fmt(rows.filter((r) => r.action === 'Suppression').length)]]} />
      </div>

      <div className="flex flex-wrap gap-px bg-slate-200">
        {['Tous', 'Modification', 'Suppression'].map((t) => (
          <button
            key={t}
            type="button"
            data-testid={`filtre-audit-${t.toLowerCase()}`}
            onClick={() => setFiltre(t)}
            className={`px-4 py-2.5 text-sm font-bold transition-colors duration-150 ${
              filtre === t ? 'bg-slate-900 text-white' : 'bg-white text-slate-700 hover:bg-slate-50'
            }`}
          >
            {t}
          </button>
        ))}
      </div>

      <section className="border border-slate-200 bg-white">
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-left" data-testid="table-audit">
            <thead>
              <tr className="border-b border-slate-200 bg-slate-50">
                {['Horodatage', 'Utilisateur', 'Action', 'Entité', 'Référence', 'Détail'].map((c) => (
                  <th key={c} className={th}>{c}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {visibles.length === 0 ? (
                <tr data-testid="audit-empty">
                  <td colSpan={6} className="px-3 py-12 text-center text-sm text-slate-500">
                    Aucune correction ni suppression enregistrée.
                  </td>
                </tr>
              ) : (
                visibles.map((r) => (
                  <tr key={r.id} data-testid={`audit-row-${r.id}`} className="border-b border-slate-100 hover:bg-slate-50">
                    <td className="px-3 py-2 font-data text-xs text-slate-600">{r.horodatage.replace('T', ' ').slice(0, 19)}</td>
                    <td className="px-3 py-2 text-sm text-slate-800">{r.utilisateur}</td>
                    <td className="px-3 py-2">
                      <span className={`font-data text-[10px] uppercase tracking-[0.08em] px-1.5 py-0.5 ${
                        r.action === 'Suppression' ? 'bg-red-50 text-red-700' : 'bg-sky-50 text-sky-800'
                      }`}>
                        {r.action}
                      </span>
                    </td>
                    <td className="px-3 py-2 text-sm text-slate-700">{r.entite}</td>
                    <td className="px-3 py-2 font-data text-sm font-semibold text-slate-900">{r.refId}</td>
                    <td className="px-3 py-2 text-sm text-slate-600">{r.resume}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
